import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import {
  Box,
  Button,
  // Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  IconButton,
  // Link,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import {
  Dispatch,
  Fragment,
  MutableRefObject,
  SetStateAction,
  useState,
} from "react";
import SignaturePad from "signature_pad";
import ErrorHelper from "../../../../../components/ErrorWrapper";
// import Flex from "../../../../../components/Flex";
import Input from "../../../../../components/Input";
// import LoadingOverlay from "../../../../../components/LoadingOverlay";
// import StyledDialog from "../../../../../components/StyledDialog";
import SignatureInput from "../../../../../components/signiture/SignatureInput";
import { useSignatureController } from "../../../../../components/signiture/use-signature-controller";
// import { useCreateDocument } from "../../../../../hooks/use-create-document";
import useDisclosure from "../../../../../hooks/use-disclosure";

export const HippaConsentButton = ({
  values,
  setFieldValue,
  viewOnly,
  // errors,
}: {
  values: any;
  setFieldValue: any;
  viewOnly?: boolean;
  errors: any;
}) => {
  const disclosureHost = useDisclosure();
  const [_k, setK] = useState<boolean>(true);
  const { canvasRef, signPad, isSignEmpty } = useSignatureController(
    disclosureHost.opened,
    values?.hippaConsentSign
  );
  // const [isLoading, setIsLoading] = useState(false);
  // const { createDocumentWithHtml, eleRef } = useCreateDocument(setIsLoading);

  // const renderContent = () => {
  //   return (
  //     <Box width={"40vw"} overflow={"hidden"}>
  //       <Box ref={eleRef}>
  //         <HIPAAConsentForm
  //           viewOnly={isPreviewVisible || viewOnly}
  //           values={values}
  //           setFieldValue={setFieldValue}
  //           canvasRef={canvasRef}
  //           signPad={signPad}
  //           setK={setK}
  //         />
  //       </Box>
  //     </Box>
  //   );
  // };

  return (
    <>
      {/* <LoadingOverlay isLoading={isLoading} />
      {!isPreviewVisible && (
        <ErrorHelper error={errors.hippaConsent}>
          <Flex gap={1} alignItems={"center"}>
            <Checkbox
              disabled={viewOnly}
              checked={values.hippaConsent}
              onChange={(_, checked) => setFieldValue("hippaConsent", checked)}
            />
            <span>
              I agree to the <b>HIPAA Consent</b> &nbsp;
              <Link href="#" onClick={() => disclosureHost.open()}>
                terms & conditions
              </Link>
              .
            </span>
          </Flex>
        </ErrorHelper>
      )}

      {!isPreviewVisible ? (
        <StyledDialog
          open={disclosureHost.opened}
          onClose={disclosureHost.close}
          dialogTitle="HIPAA Consent"
          dialogAction={
            !viewOnly ? (
              <Button
                variant="contained"
                onClick={() => {
                  setFieldValue(
                    "hippaConsentSign",
                    isSignEmpty() ? undefined : signPad?.toDataURL()
                  );

                  createDocumentWithHtml("HIPAA_Consent_Form.pdf").then(() => {
                    disclosureHost.close();
                  });
                }}
              >
                Submit
              </Button>
            ) : (
              ""
            )
          }
        >
          {renderContent()}
        </StyledDialog>
      ) : (
        renderContent()
      )} */}
      <HIPAAConsentForm
        viewOnly={viewOnly}
        values={values}
        setFieldValue={setFieldValue}
        canvasRef={canvasRef}
        signPad={signPad}
        setK={setK}
        isSignEmpty={isSignEmpty}
      />
    </>
  );
};

const HIPAAConsentForm = ({
  viewOnly,
  values,
  setFieldValue,
  canvasRef,
  signPad,
  setK,
  isSignEmpty,
}: {
  viewOnly?: boolean;
  values: any;
  setFieldValue: any;
  canvasRef: MutableRefObject<HTMLCanvasElement | null>;
  signPad: SignaturePad | undefined;
  setK: Dispatch<SetStateAction<boolean>>;
  isSignEmpty: () => boolean;
}) => {
  return (
    <Fragment>
      <Typography variant="h5" align="center" fontWeight="bold" gutterBottom>
        HIPAA Compliance Patient Consent Form
      </Typography>
      <Typography gutterBottom>
        Our Notice of Privacy Practices provides information about how we may
        use or disclose protected health information.
      </Typography>
      <Typography gutterBottom>
        The notice contains a patient's rights section describing your rights
        under the law. You ascertain that by your signature that you have
        reviewed our notice before signing this consent.
      </Typography>
      <Typography gutterBottom>
        The terms of the notice may change, if so, you will be notified at your
        next visit to update your signature/date.
      </Typography>
      <Typography gutterBottom>
        You have the right to restrict how your protected health information is
        used and disclosed for treatment, payment or healthcare operations. We
        are not required to agree with this restriction, but if we do, we shall
        honor this agreement. The HIPAA (Health Insurance Portability and
        Accountability Act of 1996) law allows for the use of the information
        for treatment, payment, or healthcare operations.
      </Typography>
      <Typography gutterBottom>
        By signing this form, you consent to our use and disclosure of your
        protected healthcare information and potentially anonymous usage in a
        publication. You have the right to revoke this consent in writing,
        signed by you. However, such a revocation will not be retroactive.
      </Typography>
      <Typography gutterBottom>
        By signing this form, I understand that:
      </Typography>
      <ul style={{ marginLeft: 24 }}>
        <li>
          Protected health information may be disclosed or used for treatment,
          payment, or healthcare operations.
        </li>
        <li>
          The practice reserves the right to change the privacy policy as
          allowed by law.
        </li>
        <li>
          The practice has the right to restrict the use of the information but
          the practice does not have to agree to those restrictions.
        </li>
        <li>
          The patient has the right to revoke this consent in writing at any
          time and all full disclosures will then cease.
        </li>
        <li>
          The practice may condition receipt of treatment upon execution of this
          consent.
        </li>
      </ul>
      <Divider sx={{ my: 1 }} />
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <FormControl component="fieldset" disabled={viewOnly}>
            <FormLabel component="legend">
              May we phone, email, or send a text to you to confirm
              appointments?
            </FormLabel>
            <RadioGroup
              row
              value={values.appointmentContact}
              onChange={(e) =>
                setFieldValue("appointmentContact", e.target.value)
              }
              name="appointmentContact"
            >
              <FormControlLabel
                disabled={viewOnly}
                value="yes"
                control={<Radio />}
                label="Yes"
              />
              <FormControlLabel
                disabled={viewOnly}
                value="no"
                control={<Radio />}
                label="No"
              />
            </RadioGroup>
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <FormControl component="fieldset" disabled={viewOnly}>
            <FormLabel component="legend">
              May we leave a message on your answering machine at home or on
              your cell phone?
            </FormLabel>
            <RadioGroup
              row
              value={values.leaveMessage}
              onChange={(e) => setFieldValue("leaveMessage", e.target.value)}
              name="leaveMessage"
            >
              <FormControlLabel
                disabled={viewOnly}
                value="yes"
                control={<Radio />}
                label="Yes"
              />
              <FormControlLabel
                disabled={viewOnly}
                value="no"
                control={<Radio />}
                label="No"
              />
            </RadioGroup>
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <FormControl component="fieldset" disabled={viewOnly}>
            <FormLabel component="legend">
              May we discuss your medical condition with any member of your
              family?
            </FormLabel>
            <RadioGroup
              row
              value={values.discussWithFamily}
              onChange={(e) =>
                setFieldValue("discussWithFamily", e.target.value)
              }
              name="discussWithFamily"
            >
              <FormControlLabel
                disabled={viewOnly}
                value="yes"
                control={<Radio />}
                label="Yes"
              />
              <FormControlLabel
                disabled={viewOnly}
                value="no"
                control={<Radio />}
                label="No"
              />
            </RadioGroup>
          </FormControl>
        </Grid>
        {values.discussWithFamily === "yes" && (
          <Grid item xs={6}>
            <Input
              label="If YES, please name the members allowed:"
              textFieldProps={{
                value: values.discussWithFamilyMemberName,
                onChange: (e) =>
                  setFieldValue("discussWithFamilyMemberName", e.target.value),
                placeholder: "Enter names of allowed family members",
                disabled: viewOnly,
              }}
            />
          </Grid>
        )}
        <Grid item xs={6}>
          <Input
            label="This Consent Was Signed By"
            textFieldProps={{
              value: values.allowedMembers,
              onChange: (e) => setFieldValue("allowedMembers", e.target.value),
              placeholder: "Enter names of allowed family members",
              disabled: viewOnly,
            }}
          />
        </Grid>
      </Grid>
      {/* You can add signature/date fields and a submit button as needed */}

      <Grid item container mt={1}>
        {viewOnly || values?.hippaConsentSign ? (
          <Box>
            <ErrorHelper label={"Signature"}>
              <Box
                style={{
                  position: "relative",
                  borderWidth: 1,
                  borderRadius: 5,
                  borderStyle: "solid",
                  height: "100%",
                }}
              >
                <img
                  src={values.hippaConsentSign}
                  style={{ height: "150px", width: "360px" }}
                />

                {!viewOnly && (
                  <IconButton
                    color="error"
                    onClick={() => {
                      setK((prev) => !prev);
                      signPad?.clear();
                      setFieldValue("hippaConsentSign", undefined);
                    }}
                    sx={{
                      position: "absolute",
                      top: -8,
                      right: -20,
                      height: "10px",
                    }}
                  >
                    <HighlightOffIcon color="error" fontSize="medium" />
                  </IconButton>
                )}
              </Box>
            </ErrorHelper>
          </Box>
        ) : (
          // <ErrorHelper>
          <Box
            width={"368px"}
            position={"relative"}
            onMouseLeave={() => {
              if (!isSignEmpty() && signPad?.toDataURL()) {
                setFieldValue("hippaConsentSign", signPad?.toDataURL());
              }
            }}
          >
            <SignatureInput
              // required
              // error={errors.hippaConsentSign }
              label="Signature"
              canvasRef={canvasRef}
              w="368px"
              h="100px"
            />

            <Button
              variant="contained"
              sx={{
                position: "absolute",
                bottom: 10,
                left: "300px",
                height: "24px",
              }}
              onClick={() => {
                setK((prev) => !prev);
                signPad?.clear();
              }}
            >
              clear
            </Button>
          </Box>
          // </ErrorHelper>
        )}
      </Grid>
    </Fragment>
  );
};
